<!-- 值班信息 -->
<template>
  <div class="beOnDuty">
    <div class="pup_head">
      <div class="flex">
        <div class="pup_img">
          <img
            src="~@/assets/zong_lan_ye_img/jinye.png"
            style="width: 100%; height: 100%"
            alt
          />
        </div>
        <div class="fontOne">无人机值班领导及责任民警一览表</div>
      </div>
      <div class="flex">
        <div class="flex"></div>
        <div class="fontTwo" @click="pupClose">关闭</div>
      </div>
    </div>
    <div class="nei">
      <div class="kuang">
        <div class="tr">
          <div class="center">辖区</div>
          <div class="center">驻点名称</div>
          <div class="center">责任领导</div>
          <div class="center">责任民警</div>
          <!-- <div class=" center">值班辅警</div> -->
        </div>
        <div class="contain" v-infinite-scroll="load">
          <div
            class="dutybox mt10 addInput"
            v-for="(item, index) in dutyInfo"
            :key="index"
          >
            <div>{{ item.xq }}</div>
            <div>{{ item.address }}</div>
            <div>{{ item.ld }}</div>
            <div>{{ item.mj }}</div>
            <!-- <div >{{ item.fj }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dutyInfo: [],
    };
  },
  computed: {
    ...mapGetters(["user_info"]),
  },
  mounted() {},
  methods: {
    pupClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style scoped lang="scss">
.beOnDuty {
  width: 850px;
  height: 574px;
  background: rgba(12, 34, 73, 0.7);
  border-radius: 10px;
  border: 1px solid rgba(26, 92, 246, 0.5);
  backdrop-filter: blur(1px);
}

.WorkLog_img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.flex {
  display: flex;
}

.pup_head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 16px 0 12px;
  align-items: center;
  height: 32px;
  background: linear-gradient(
    180deg,
    #9198ff 0%,
    rgba(45, 81, 153, 0.45) 40%,
    #05091a 100%
  );
  box-shadow: inset 0px 0px 10px 2px #3f9dff;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid #427dff;

  .pup_img {
    display: flex;
    width: 19px;
    height: 25px;
    margin: 0 4px 0 0;
  }

  .fontOne {
    font-size: 20px;
    font-family: YouSheBiaoTiHei;
    color: #14faff;
    line-height: 26px;
    text-shadow: 0px 1px 1px rgba(2, 32, 56, 0.2);
    background: linear-gradient(
      135deg,
      #e3aa77 0%,
      #f5cda9 38%,
      #f9ecd3 58%,
      #fcdbb1 79%,
      #edb07a 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .fontTwo {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #d2dfff;
    cursor: pointer;
    line-height: 20px;
  }
}

.nei {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
}

.kuang {
  width: 830px;
  height: 518px;
  background: rgba(8, 26, 58, 0.8);
  border-radius: 4px;
  border: 1px solid #315ec7;
  box-sizing: border-box;
  padding: 4px 4px 4px 10px;
}

.tr {
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-family: YouSheBiaoTiHei;
  color: #ebf9ff;
  line-height: 22px;
  div {
    width: calc(100% / 4);
  }
}

.th_tt {
  width: 100px;
}

.td {
  /deep/.el-input__suffix {
    display: none;
  }
}

.icon-baocun {
  font-size: 23px;
  color: #00ffff;
}

.focus {
  pointer-events: none;
  color: #92d9ff;
}

.contain {
  height: 462px;
  overflow: hidden;
  overflow-y: scroll;

  .dutybox:nth-child(odd) {
    background: rgba(73, 135, 210, 0.2);
  }

  .dutybox:nth-child(even) {
    background: transparent;
  }
}

.dutybox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    text-align: center;
    font-size: 12px;
    line-height: 30px;
    min-height: 30px;
    color: #92d9ff;
    width: calc(100% / 4);
  }
}

.infobox {
  position: fixed;
  left: 35%;
  top: 200px;
  width: 683px;
  height: 348px;
  background: rgba(22, 29, 45, 0.9);
  border: 1px solid #009fff;
  box-shadow: inset 0 0 7px 0 #008fff;
  border-radius: 10px;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #009fff;
}

/deep/.el-input__prefix {
  top: -6px;
}

/deep/ .el-input__suffix {
  top: -6px;
}

::v-deep {
  .timeDate_input {
    border: 1px solid #00b6ff;
    box-shadow: inset 0 0 3px 0 #00b6ff;
    border-radius: 4px;
    width: 184px;
    height: 27px;

    .el-input__inner {
      height: 27px;
    }
  }

  .el-input .el-input__clear {
    line-height: 30px;
  }
}
/deep/ .el-select-dropdown {
  left: auto !important;
  top: auto !important;
}
</style>
